import { render, staticRenderFns } from "./ReplayOverlay.vue?vue&type=template&id=c5d4ef86&scoped=true"
import script from "./ReplayOverlay.vue?vue&type=script&lang=ts"
export * from "./ReplayOverlay.vue?vue&type=script&lang=ts"
import style0 from "./ReplayOverlay.vue?vue&type=style&index=0&id=c5d4ef86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d4ef86",
  null
  
)

export default component.exports